import { render, staticRenderFns } from "./LicenseCheck.vue?vue&type=template&id=3c0df916&scoped=true"
import script from "./LicenseCheck.vue?vue&type=script&lang=js"
export * from "./LicenseCheck.vue?vue&type=script&lang=js"
import style0 from "./LicenseCheck.vue?vue&type=style&index=0&id=3c0df916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0df916",
  null
  
)

export default component.exports